import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex gap-1 emoji-container"
}
const _hoisted_2 = { class: "emoji-item" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  id: "reactions-dropdown",
  class: "dropdown-menu p-0 reactions-dropdown",
  "aria-labelledby": "User-Reactions"
}
const _hoisted_5 = { class: "weight-600 name-text" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-secondary" }, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "btn reactions-btn"
}
const _hoisted_10 = {
  class: "emoji-item",
  "data-bs-toggle": "dropdown",
  "data-bs-offset": "0,8"
}
const _hoisted_11 = { class: "fw-bold" }
const _hoisted_12 = { class: "name-text" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-secondary" }, null, -1 /* HOISTED */)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmojiPicker = _resolveComponent("EmojiPicker")!

  return (_ctx.message.messageReactions && Object.keys(_ctx.message.messageReactions).length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" First 4 Reactions "),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleReactions, (reactionList, reaction) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "btn reactions-btn",
            key: reaction
          }, [
            _createElementVNode("span", _hoisted_2, [
              _createTextVNode(_toDisplayString(reaction) + " ", 1 /* TEXT */),
              (reactionList.length > 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(reactionList.length), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            _createCommentVNode(" Dropdown of users for that emoji "),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["users-list", { 'custom-scrollbar': _ctx.userOs == 'Windows' }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reactionList, (react) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: react.id,
                    class: "d-flex justify-content-between align-items-center px-3 py-2"
                  }, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(react.senderDetails.firstName) + " " + _toDisplayString(react.senderDetails.lastName), 1 /* TEXT */),
                    (_ctx.loggedInUserDetails?.userId === react.senderUserId)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.handleEmoji(react.emoji)),
                          class: "dialog-close"
                        }, _hoisted_8, 8 /* PROPS */, _hoisted_6))
                      : _createCommentVNode("v-if", true)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ], 2 /* CLASS */)
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */)),
        _createCommentVNode(" + EXTRA Reactions Button "),
        (_ctx.extraReactionsCount > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, " +" + _toDisplayString(_ctx.extraReactionsCount), 1 /* TEXT */),
              _createCommentVNode(" Dropdown of ALL remaining reactions "),
              _createElementVNode("div", {
                id: "more-reactions-dropdown",
                class: _normalizeClass(["dropdown-menu p-0 reactions-dropdown", { 'custom-scrollbar': _ctx.userOs == 'Windows' }])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["users-list p-2", { 'custom-scrollbar': _ctx.userOs == 'Windows' }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extraReactions, (reactionList, reaction) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: reaction,
                      class: "extra-reaction-block"
                    }, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(reaction) + " " + _toDisplayString(reactionList.length > 1 ? "(" + reactionList.length + ")" : ""), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reactionList, (react) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: react.id,
                          class: "d-flex justify-content-between align-items-center mt-1"
                        }, [
                          _createElementVNode("span", _hoisted_12, _toDisplayString(react.senderDetails.firstName) + " " + _toDisplayString(react.senderDetails.lastName), 1 /* TEXT */),
                          (_ctx.loggedInUserDetails?.userId === react.senderUserId)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.handleEmoji(react.emoji)),
                                class: "dialog-close"
                              }, _hoisted_15, 8 /* PROPS */, _hoisted_13))
                            : _createCommentVNode("v-if", true)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 2 /* CLASS */)
              ], 2 /* CLASS */)
            ]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_EmojiPicker, { onEmojiSelected: _ctx.handleEmoji }, null, 8 /* PROPS */, ["onEmojiSelected"])
      ]))
    : _createCommentVNode("v-if", true)
}